import { render, staticRenderFns } from "./CaseReportFullScreen.vue?vue&type=template&id=30f6d2d7&"
import script from "./CaseReportFullScreen.vue?vue&type=script&lang=js&"
export * from "./CaseReportFullScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports